import Vue from 'vue';
import Router from 'vue-router';
import CommonStep from 'components/vpm-steps/common-step.vue';
Vue.use(Router);
export default new Router({
    linkActiveClass: 'active',
    routes: [{
        path: '/',
        redirect: '/VPMsteps-1'
    }, {
        path: '/VPMsteps-1',
        name: 'Installation of Application',
        component: CommonStep,
        props: { nkey: 'installation' }
    }, {
        path: '/VPMsteps-2',
        name: 'Define Navigation Tree',
        component: CommonStep,
        props: { nkey: 'navigation' }
    }, {
        path: '/VPMsteps-3',
        name: 'Build Floorplan',
        component: CommonStep,
        props: { nkey: 'floorplan' }
    }, {
        path: '/VPMsteps-4',
        name: 'Add Devices',
        component: CommonStep,
        props: { nkey: 'devices' }
    }, {
        path: '/VPMsteps-5',
        name: 'Place Floormount Devices',
        component: CommonStep,
        props: { nkey: 'place' }
    }, {
        path: '/VPMsteps-6',
        name: 'Auto Discovery',
        component: CommonStep,
        props: { nkey: 'discovery' }
    }, {
        path: '/VPMsteps-7',
        name: 'Rack Building',
        component: CommonStep,
        props: { nkey: 'rack' }
    }, {
        path: '/VPMsteps-8',
        name: 'Port Mapping',
        component: CommonStep,
        props: { nkey: 'port' }
    }, {
        path: '/VPMsteps-9',
        name: 'Device Settings',
        component: CommonStep,
        props: { nkey: 'device' }
    }, {
        path: '/VPMsteps-10',
        name: 'Alarm Settings',
        component: CommonStep,
        props: { nkey: 'alarm' }
    }]
});


// WEBPACK FOOTER //
// ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--2-1!./src/router/index.ts